import { isProd } from "../env";

/*
  Use this to track events where interoperability between control-panel-legacy and control-panel is required, i.e. primarily the "standalone" components.
  Prefer using `AnalyticsProvider` and `useAnalytics` hook for tracking events in the React application where possible.
*/
export const interop_trackEvent = (event: string, properties: any) => {
  if (!isProd()) {
    console.debug(`[track_event] ${event}`, properties);
    return;
  }
  window?.["heap"]?.track(event, properties); // heap
  window?.["analytics"]?.track(event, properties); // segment
};
